import { NotificationResponseModel } from '../../../../types/NotificationModels';

export const getNotificationLink = (
  notification: NotificationResponseModel
): string | undefined => {
  if (!notification.messageData) return undefined;

  try {
    const parsedData = JSON.parse(notification.messageData);

    if (notification.notificationTypeString === 'AvailabilityAdded') {
      const professionalId =
        parsedData?.ProfessionalId || parsedData?.professionalId;
      if (professionalId) {
        return `/profile?professionalId=${professionalId}`;
      }
    }

    if (notification.notificationTypeString === 'AvailabilityRequested') {
      return '/availability-management';
    }

    let bookingIds: (string | number)[] | undefined;

    if (
      parsedData?.BookingIds &&
      Array.isArray(parsedData.BookingIds) &&
      parsedData.BookingIds.length > 0
    ) {
      bookingIds = parsedData.BookingIds;
    } else if (
      parsedData?.bookingIds &&
      Array.isArray(parsedData.bookingIds) &&
      parsedData.bookingIds.length > 0
    ) {
      bookingIds = parsedData.bookingIds;
    } else if (Array.isArray(parsedData) && parsedData.length > 0) {
      bookingIds = parsedData;
    }

    if (bookingIds && bookingIds.length > 0) {
      const isBookingRequest =
        notification.notificationTypeString === 'BookingRequested' ||
        notification.title.toLowerCase().includes('booking request');
      if (isBookingRequest) {
        return `/booking-decision?bookingIds=${bookingIds.join(',')}`;
      }
      return `/booking/${bookingIds[0]}`;
    }
  } catch (e) {
    console.error('Error parsing notification messageData', e);
  }

  return undefined;
};
